import client from "../modules/client";
import HelperService from "./helper-service";

export const getList = () => {
    return client(`/api/v2/categories`).then(({ data }) => data);
};

export const getBanners = () => {
    return client(`/api/v0/homepage/banner`).then(({ data }) => data?.banners);
};

export const getTopTrainers = () => {
    return client(`/api/v0/homepage/topTrainers?limit=20`).then(({ data }) => data?.trainers);
};

export const discoverClassesByCategories = (filter) => {
    let query = HelperService.getFilterQueryString({
        limit: filter.limit || 20,
        offset: filter.offset || 0,
        keyword: filter.search,
        radius: HelperService.getRadius(filter),
        lat: filter.lat,
        lon: filter.lon,
        search: filter.search,
        age: filter.age,
        datetimeFrom: filter.datetimeFrom || (new Date()).getTime(),
        datetimeTo: filter.datetimeTo,
        duration: filter.duration,
        daypart: filter.daypart,
        sweatequity: filter.sweatequity,
        difficulty: filter.difficulty,
        sweatmeter: filter.sweatmeter,
        popup: filter.popup,
        special: filter.special,
        categories: filter.categories,
        excludeCategories: filter.excludeCategories,
    });
    return client(`/api/v0/discover/categories/WHATS_NEW?${query}`).then(({ data }) => data?.classes);
};
export const discoverPopupClassesByCategories = (filter) => {
    let query = HelperService.getFilterQueryString({
        limit: filter.limit || 20,
        offset: filter.offset || 0,
        keyword: filter.search,
        radius: HelperService.getRadius(filter),
        lat: filter.lat,
        lon: filter.lon,
        search: filter.search,
        age: filter.age,
        datetimeFrom: filter.datetimeFrom || (new Date()).getTime(),
        datetimeTo: filter.datetimeTo,
        duration: filter.duration,
        daypart: filter.daypart,
        sweatequity: filter.sweatequity,
        difficulty: filter.difficulty,
        sweatmeter: filter.sweatmeter,
        popup: filter.popup,
        special: filter.special,
        categories: filter.categories,
        excludeCategories: filter.excludeCategories,
    });
    return client(`/api/v0/discover/categories/POPUP?${query}`).then(({ data }) => data?.classes);
};
export const discoverClassesByCourses = (courseID, filter) => {
    return client(`/api/v0/discover/courses/${courseID}?lat=${filter.lat}&lon=${filter.lon}&radius=${HelperService.getRadius(filter)}`).then(({ data }) => data?.classes);
};
export const discoverClassesByPlaces = (placeID, filter) => {
    return client(`/api/v0/discover/places/${placeID}?lat=${filter.lat}&lon=${filter.lon}&radius=${HelperService.getRadius(filter)}`).then(({ data }) => data?.classes);
};

export function useHomepageService () {
    return {
        getList,
        getBanners,
        getTopTrainers,
        discoverClassesByCategories,
        discoverPopupClassesByCategories,
        discoverClassesByCourses,
        discoverClassesByPlaces,
    };
}
